import React from 'react';
import { NewTemplateData } from '../../../../api/endpoints/templates';
import { Star } from '../../../../ui/Star';
import { Copy, Flexer } from '../../elements/LayoutElements';
import { useOnCreateBoardFromTemplate, useTemplateStarred } from '../TemplateHooks';
import { TemplateActionMenu } from './TemplateActionMenu';
import { TemplateCard } from './TemplateCard';

export type TemplateWithStarData = NewTemplateData & { team: boolean, starred: boolean };

const TemplateListItem = React.memo<{ template: TemplateWithStarData }>(({ template }) => {

    const onCreate = useOnCreateBoardFromTemplate();
    const [starred, toggleStarred] = useTemplateStarred(template);

    return <TemplateCard.Wrapper key={template.id}>
        <TemplateCard clickable onClick={() => onCreate({ templateId: template.id, autoOpen: true, forcePromptForLocation: true })}>
            <TemplateCard.Image>
                <TemplateCard.Thumb id={template.id} thumbUrl={template.thumbUrl} />

            </TemplateCard.Image>
            <TemplateCard.Info>
                <TemplateCard.Header>
                    <TemplateCard.Label title={template.label}>
                        {template.label}
                    </TemplateCard.Label>
                </TemplateCard.Header>
                <TemplateCard.Body>
                    <Copy>{template.description}</Copy>
                </TemplateCard.Body>
                <TemplateCard.Footer>
                    <TemplateCard.TagList>
                        {template.tags.map(x => <TemplateCard.Tag key={x.id} color={x.color}>{x.label}</TemplateCard.Tag>)}
                    </TemplateCard.TagList>
                </TemplateCard.Footer>
            </TemplateCard.Info>
        </TemplateCard>
        <TemplateCard.ActionMenu>
            <TemplateActionMenu {...{ template }} />
        </TemplateCard.ActionMenu>
        <TemplateCard.StarButton active={starred}>
            <Star size="2" active={starred} onClick={toggleStarred} />
        </TemplateCard.StarButton>
    </TemplateCard.Wrapper>;
});

export const TemplateListView = React.memo<{ templates: TemplateWithStarData[], center?: boolean }>(({ templates, center }) => {

    return <Flexer flex="row" gap="2" wrap="wrap" justify={center ? 'center' : 'start'}>
        {templates?.map(x => <TemplateListItem key={x.id} template={x} />)}
    </Flexer >;
});
